module.exports = __webpack_public_path__ + "img/1632.aec51a9e.gif";